import React from "react";
import {
  Link as RouterLink,
  LinkProps as RouterLinkProps,
//   MemoryRouter,
} from 'react-router-dom';

const LinkBehavior = React.forwardRef<any, Omit<RouterLinkProps, 'to'> 
& { href: RouterLinkProps['to'] } >((props, ref) => {
const { href, ...other } = props;
// Map href (MUI) -> to (react-router)
return (<RouterLink ref={ref} to={href} {...other} />);
});

export default LinkBehavior;